<template>
    <div class="keyboard-container">
        <div class="android-keyboard">
            <!-- <div class="line control">
                <button class="control-buttons" v-for="(button, key) in controlButtons" :key="key"
                    @click="button['task']()" v-if="button.visible">
                    <span v-if="button.text" v-text="button.text"></span>
                    <img v-if="button.icon" :src="button.icon" />
                </button>
            </div> -->
            <div v-for="(line, key) in getLayoutLines()" :key="key" class="line">
                <div v-for="(button, key2) in getLineButtons(line)" :key="key2" class="button-container" :class="{ 'round-container': roundNumeric }">
                    <span v-if="button === '{accept}'" @click="acceptFunction()" class="button"
                        :class="{ 'big': bigNumeric, 'green-btn': bigNumeric }" :style="getDinamicWidth(line)">{{
                            getString('keyboard_accept') }}
                    </span>
                    <span v-else-if="button === '{clear}'" @click="clear()" class="button"
                        :class="{ 'big': bigNumeric, 'min-width': !bigNumeric, 'clear-btn': bigNumeric, 'round-numeric-btn': roundNumeric }"
                        :style="!roundNumeric ? getDinamicWidth(line) : ''">{{ getString('keyboard_clear') }}
                    </span>
                    <div v-else-if="button === '{backspace}'" @click="backspace()" class="button backspace-btn"
                        :class="{ 'big': bigNumeric, 'min-width': !bigNumeric, 'round-numeric-btn': roundNumeric }" :style="!roundNumeric ? getDinamicWidth(line) : ''"><img
                            :src="backspaceImg">
                    </div>
                    <div v-else-if="button === '{shift}'" @click="shift()" class="button shift-btn"
                        :class="{ 'big': bigNumeric }" :style="getDinamicWidth(line)"><img
                            :src="keyboardShifted ? shiftFilledImg : shiftImg">
                    </div>
                    <div v-else-if="button === '{space}'" @click="enqueueSpace()" class="button space-btn"
                        :class="{ 'big': bigNumeric }">{{ getString('keyboard_space') }}
                    </div>
                     <div v-else-if="button === '{paste}' && clipBoardText" @click="paste()" class="button"
                        :class="{ 'big': bigNumeric }">{{ getString('colar') }}
                    </div>
                    <span v-else @click="handleInputKey(button)" class="button" :class="{ 'big': bigNumeric, 'round-numeric-btn': roundNumeric }"
                        :style="!roundNumeric ? getDinamicWidth(line) : ''">{{ button }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import LocaleController from '@/assets/controllers/LocaleController'
import Util from '@/assets/libs/util'

export default {
    name: 'AndroidKeyboard',
    components: {

    },
    props: [
        'layout',
        'accept',
        'inputElement', // Tem que ser uma DIV, não um input
        'bigNumeric',
        'onInput',
        'maxCaracteres',
        'isPasswordField',
        'roundNumeric'
    ],
    watch: {
        maxCaracteres: function (newVal, oldVal) {
            this.reapplyMaxCaracteresAndMasks(newVal)
        }
    },
    data () {
        return {
            backspaceImg: require('../../../static/icons/backspace.svg'),
            shiftImg: require('../../../static/icons/shift.svg'),
            shiftFilledImg: require('../../../static/icons/shift-fill.svg'),
            enqueuedSpace: false,
            keyboardShifted: false,
            clipBoardText: '',
            interval: null,
            controlButtons: [
                {
                    id: 'past',
                    text: 'Colar',
                    task: this.paste,
                    visible: false,
                    icon: '' // require('../../../static/icons/paste.svg')
                }
            ]
        }
    },
    mounted () {
        document.addEventListener('keydown', this.colarConteudo)
        this.interval = setInterval(this.getConteudo, 1000)
    },
    beforeDestroy () {
        if (this.keyboardShifted) this.shift()
        document.removeEventListener('keydown', this.colarConteudo)
        clearInterval(this.interval)
    },
    methods: {
        async colarConteudo (event) {
            // Verifica se a tecla é 'v' e Ctrl está pressionado
            if (event.key === 'v' && event.ctrlKey) {
                try {
                    // Captura conteudo do clipboard
                    if (Util.isAndroidMode()) {
                        this.clipBoardText = window.AndroidClipboard.getClipboardText()
                    } else {
                        this.clipBoardText = await navigator.clipboard.readText()
                    }
                    this.handleInputKey(this.clipBoardText)
                    // const texto = await navigator.clipboard.readText()
                } catch (error) {
                    // console.error('Erro ao ler o clipboard:', error)
                }
                event.preventDefault()
            }
        },
        getConteudo: async function () {
            try {
                // Captura conteudo do clipboard
                if (Util.isAndroidMode()) {
                    this.clipBoardText = window.AndroidClipboard.getClipboardText()
                } else {
                    this.clipBoardText = await navigator.clipboard.readText()
                }
                if (this.clipBoardText) {
                    this.controlButtons[0].visible = true
                }
                // this.handleInputKey(this.clipBoardText)
                // const texto = await navigator.clipboard.readText()
            } catch (error) {
                this.clipBoardText = ''
                // console.error('Erro ao ler o clipboard:', error)
            }
        },
        paste: function () {
            this.handleInputKey(this.clipBoardText)
        },
        getString: function (key) {
            return LocaleController.getString(key)
        },
        getLayoutLines: function () {
            return this.layout.default
        },
        getLineButtons: function (line) {
            let cleanedLine = Util.deepCopy(line)
            cleanedLine = cleanedLine.split(' ')
            this.removeZeroFunction(cleanedLine)
            this.removeNextFunction(cleanedLine)
            this.checkPastButton(cleanedLine)
            return cleanedLine
        },
        removeZeroFunction: function (cleanedLine) {
            let indexOfZero = cleanedLine.findIndex(element => element === '{zero}')
            if (indexOfZero !== -1) cleanedLine.splice(indexOfZero, 1, '0')
        },
        removeNextFunction: function (cleanedLine) {
            let indexOfNext = cleanedLine.findIndex(element => element === '{next}')
            if (indexOfNext !== -1) cleanedLine.splice(indexOfNext, 1)
        },
        checkPastButton: function (cleanedLine) {
            let indexOfPaste = cleanedLine.findIndex(element => element === '{paste}')
            if (indexOfPaste !== -1 && !this.clipBoardText) cleanedLine.splice(indexOfPaste, 1)
        },
        inputIsValidDiv: function () {
            return this.inputElement != null && this.inputElement.tagName === 'DIV'
        },
        isValidFunction: function (functionToTest) {
            return functionToTest && typeof functionToTest === 'function'
        },
        acceptFunction: function () {
            if (this.isValidFunction(this.accept)) {
                this.accept()
            }
        },
        clear: function () {
            if (this.inputIsValidDiv()) {
                if (this.isPasswordField) this.$emit('passwordFieldCleaned')
                this.inputElement.innerText = ''
            }
        },
        backspace: function () {
            if (this.inputIsValidDiv()) {
                if (this.isPasswordField) this.$emit('passwordCharacterErased')
                this.inputElement.innerText = this.inputElement.innerText.slice(0, -1)
                if (this.onInput) {
                    this.inputElement.innerText = this.onInput(this.inputElement.innerText)
                }
            }
        },
        handleInputKey: function (key) {
            if (this.inputIsValidDiv()) {
                let maxCaracteresNotReached = !this.maxCaracteres || this.inputElement.innerText.length < this.maxCaracteres
                if (maxCaracteresNotReached) {
                    if (this.isPasswordField) {
                        this.$emit('passwordCharacterTyped', key)
                        this.inputElement.innerText += [...key].map(e => '*').join('')
                    } else {
                        this.inputElement.innerText += this.enqueuedSpace ? ' ' + key : key
                        this.enqueuedSpace = false
                        if (this.onInput) {
                            this.inputElement.innerText = this.onInput(this.inputElement.innerText)
                        }
                    }
                }
            }
        },
        getDinamicWidth: function (line) {
            return `width: calc(100vw / ${line.length} - 80px);`
        },
        reapplyMaxCaracteresAndMasks: function (newVal) {
            if (this.inputIsValidDiv()) {
                if (this.inputElement.innerText !== '' && this.inputElement.innerText.length > newVal) {
                    this.inputElement.innerText = this.inputElement.innerText.slice(0, newVal)
                }

                if (this.inputElement.innerText !== '' && this.onInput) {
                    this.inputElement.innerText = this.onInput(this.inputElement.innerText)
                }
            }
        },
        enqueueSpace: function () {
            this.enqueuedSpace = true
        },
        shift: function () {
            try {
                let layoutLines = this.getLayoutLines()

                for (let i = 0; i < layoutLines.length; i++) {
                    let buttons = this.getLineButtons(layoutLines[i])

                    for (let j = 0; j < buttons.length; j++) {
                        let currentButton = buttons[j]
                        let isFunctionButton = currentButton.includes('{') && currentButton.includes('}')

                        if (!isFunctionButton) {
                            if (this.keyboardShifted) buttons[j] = currentButton.toLowerCase()
                            else buttons[j] = currentButton.toUpperCase()
                        }

                        layoutLines[i] = buttons.join(' ')
                    }
                }

                this.keyboardShifted = !this.keyboardShifted
                this.$forceUpdate()
            } catch (error) {
                console.log(error.message)
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../../assets/common.less");

.keyboard-container {
    .android-keyboard {

        .line {
            display: flex;
            justify-content: space-evenly;

            .control-buttons {
                box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.8);
                display: flex;
                justify-content: center;
                align-items: center;
                color: white;
                font-size: 30px;
                height: 70px;
                // background-color: #2a1500;
                background-color: @primary-dark;
                flex-grow: 1;
                margin: 10px;
                border-radius: 10px;
                max-width: max-content;
                min-width: 70px;

                // max-width: 100px;
                img {
                    height: 95%;
                    width: auto;
                    filter: invert(100%);
                    padding-left: 3px;
                }
            }

            .button-container {
                display: flex;
                flex-grow: 1;

                .button {
                    box-shadow: 3px 3px 3px rgba(0, 0, 0, 0.8);
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: white;
                    font-size: 35px;
                    height: 70px;
                    // background-color: #2a1500;
                    background-color: @primary-dark;
                    flex-grow: 1;
                    margin: 10px;
                    border-radius: 10px;

                    .backspace-btn {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }

                }

                .shift-btn {
                    min-width: 30px;
                }

                .min-width {
                    min-width: 50px;
                }
            }

            .button-container:active {
                transform: translateY(2px);
            }
        }

        .big {
            height: 120px !important;
            font-size: 60px !important;
        }

        .green-btn {
            font-size: 35px !important;
            background-color: #12830e !important;
        }

        .clear-btn {
            font-size: 35px !important;
        }

        .space-btn {
            width: 350px;
        }

        // ===== ESTILOS PARA TECLADO NUMÉRICO REDONDO =====
        // Aplicado apenas quando roundNumeric = true

        .round-container {
            justify-content: center;
            align-items: center;
        }

        .round-numeric-btn {
            background-color: white !important;
            color: #333 !important;
            border: 2px solid rgba(0, 0, 0, 0.1) !important;
            border-radius: 50% !important;
            width: 160px !important;
            height: 160px !important;
            min-width: 160px !important;
            max-width: 180px !important;
            flex-grow: 0 !important;
            flex-shrink: 0 !important;
            aspect-ratio: 1 / 1;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15) !important;
            font-size: 65px !important;

            &.clear-btn {
                font-size: 32px !important;
            }

            img {
                filter: invert(0) !important;
                filter: brightness(0.2) !important;
                opacity: 1 !important;
            }
        }
    }
}

@media (max-width: 698px) {

    // Gertec SK210
    .keyboard-container {
        border-radius: 0px !important;
        .android-keyboard {
            .line {
                .control-buttons {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    font-size: 15px;
                    height: 30px;
                    flex-grow: 1;
                    margin: 5px;
                    border-radius: 5px;
                    max-width: max-content;
                    min-width: 30px;

                    // max-width: 100px;
                    img {
                        height: 95%;
                        width: auto;
                        filter: invert(100%);
                        padding-left: 3px;
                    }
                }

                .button-container {
                    .button {
                        font-size: 20px;
                        height: 35px;
                        margin: 3px;
                        border-radius: 5px;
                        box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.8);
                        img {
                            width: 24px;
                        }
                    }

                    // .shift-btn {
                    //     min-width: 30px;
                    // }

                    // .min-width {
                    //     min-width: 50px;
                    // }
                }

                // .button-container:active {
                //     transform: translateY(2px);
                // }
            }

            .big {
                height: 45px !important;
                font-size: 22px !important;
                margin: 5px !important;
            }

            // .green-btn {
            //     font-size: 35px !important;
            //     background-color: #12830e !important;
            // }

            // .clear-btn {
            //     font-size: 35px !important;
            // }

            .space-btn {
                width: 250px;
            }

            // ===== ESTILOS PARA TECLADO NUMÉRICO REDONDO - TELAS PEQUENAS =====
            .round-container {
                justify-content: center;
                align-items: center;
            }

            .round-numeric-btn {
                background-color: white !important;
                color: #333 !important;
                border: 1px solid rgba(0, 0, 0, 0.1) !important;
                border-radius: 50% !important;
                width: 65px !important;
                height: 65px !important;
                min-width: 65px !important;
                max-width: 65px !important;
                flex-grow: 0 !important;
                flex-shrink: 0 !important;
                aspect-ratio: 1 / 1;
                box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15) !important;
                font-size: 28px !important;

                &.clear-btn {
                    font-size: 14px !important;
                }

                img {
                    width: 30px !important;
                }
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    .keyboard-container {
        // width: auto !important;
        // padding: .5em !important;

        .android-keyboard {
            .line {
                .control-buttons {
                    font-size: 25px;
                    height: 65px;
                    margin: 5px;
                    min-width: 65px;

                    // max-width: 100px;
                    img {
                        height: 80%;
                        width: auto;
                        filter: invert(100%);
                        padding-left: 3px;
                    }
                }

                .button-container {
                    .button {
                        height: 65px;
                        margin: 5px !important;
                        font-size: 1.8rem;

                        .backspace-btn {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }

                    }

                    .shift-btn {
                        min-width: 30px;
                    }

                    .min-width {
                        min-width: 50px;
                    }
                }

                .button-container:active {
                    transform: translateY(2px);
                }
            }

            .big {
                height: 80px !important;
                font-size: 50px !important;
            }

            .green-btn {
                font-size: 35px !important;
                background-color: #12830e !important;
            }

            .clear-btn {
                font-size: 35px !important;
            }

            .space-btn {
                width: 350px;
            }

            // ===== ESTILOS PARA TECLADO NUMÉRICO REDONDO - TABLETS =====
            .round-container {
                justify-content: center;
                align-items: center;
            }

            .round-numeric-btn {
                background-color: white !important;
                color: #333 !important;
                border: 2px solid rgba(0, 0, 0, 0.1) !important;
                border-radius: 50% !important;
                width: 120px !important;
                height: 120px !important;
                min-width: 120px !important;
                max-width: 120px !important;
                flex-grow: 0 !important;
                flex-shrink: 0 !important;
                aspect-ratio: 1 / 1;
                box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15) !important;
                font-size: 55px !important;

                &.clear-btn {
                    font-size: 26px !important;
                }

                img {
                    width: 50px !important;
                }
            }
        }
    }
}

@media (orientation: landscape) {
    .keyboard-container {
        width: auto !important;
        padding: .5em !important;

        .android-keyboard {
            .line {
                .button-container {
                    .button {
                        height: 50px;
                        margin: 6px !important;
                        font-size: 1.6rem !important;

                        .backspace-btn {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }

                    }

                    .shift-btn {
                        min-width: 30px;
                    }

                    .min-width {
                        min-width: 45px;
                    }
                }

                .button-container:active {
                    transform: translateY(2px);
                }
            }

            .big {
                height: 60px !important;
                font-size: 50px !important;
            }

            .green-btn {
                font-size: 35px !important;
                background-color: #12830e !important;
            }

            .clear-btn {
                font-size: 35px !important;
            }

            .space-btn {
                width: 350px;
            }

            // ===== ESTILOS PARA TECLADO NUMÉRICO REDONDO - LANDSCAPE =====
            .round-container {
                justify-content: center;
                align-items: center;
            }

            .round-numeric-btn {
                background-color: white !important;
                color: #333 !important;
                border: 1.5px solid rgba(0, 0, 0, 0.1) !important;
                border-radius: 50% !important;
                width: 90px !important;
                height: 90px !important;
                min-width: 90px !important;
                max-width: 90px !important;
                flex-grow: 0 !important;
                flex-shrink: 0 !important;
                aspect-ratio: 1 / 1;
                box-shadow: 0 1px 5px rgba(0, 0, 0, 0.15) !important;
                font-size: 45px !important;

                &.clear-btn {
                    font-size: 22px !important;
                }

                img {
                    width: 40px !important;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/AndroidKeyboard/AndroidKeyboard.vue